import React, { useEffect, useState } from 'react';
import { Label } from '../atoms/label';
import { InputText } from '../atoms/inputText';
import useMedia from 'use-media';
export const InputForm = (props) => {

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const isWidePhone = useMedia({ maxWidth: '480px' });

    const [name, setName] = useState("");

    useEffect(() => {
        setName(props.value);
    }, [props]);

    const getName = (e) => {
        setName(e.target.value);
    }

    return (
        <div style={styles.content}>
            <Label label={props.label} style={props.style} className={props.labelClass}/>
            <InputText
                id={props.id}
                class={props.class}
                type={props.type}
                style={isWideTablet ? styles.input2 : styles.input}
                maxLength={props.maxLength}
                placeholder={props.placeholder}
                onChange={getName}
                value={name}
                disabled={props.disabled}
            />
        </div>
    );
}
const styles = {
    content: {
        textAlign: "left",
        width: "100%",
        marginBottom: "1rem",
        marginRight: 5,
        marginLeft: 5,
        fontSize: "100%"
    },

    input: {
        borderWidth: 1.5,
        borderColor: "#6f6f6f",
        margin: "0px",
        width: "calc(100% - 20px)",
        height: "2rem",
        border: "solid 1px #b7b7b7",
        padding: "5px 10px",
        letterSpacing: 3,
        fontSize: 17,
        //cursor:"pointer",
    },
    input2: {
        borderWidth: 1.5,
        borderColor: "#6f6f6f",
        margin: "0px 0px 5px 0px",
        width: "calc(100% - 20px)",
        border: "solid 1px #b7b7b7",
        padding: "5px 10px",
        fontSize: 14,
        lineHeight: "1.5em",
        letterSpacing: "0.2rem",
        //cursor:"pointer",
    }
}